import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/pdf.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-8093cd88")

_pushScopeId("data-v-8093cd88")
const _hoisted_1 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = { class: "dialog-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.ProperAllTextDocumentDownload,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
    footerType: "customize"
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "document-item",
          key: item
        }, [
          _hoisted_1,
          _createVNode("a", {
            href: '/download/template/'+item,
            title: _ctx.$wordList.ProperAllTextClickToDown,
            download: item.replace(/_/g,' ')
          }, _toDisplayString(item.replace(/_/g," ")), 9, ["href", "title", "download"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["title"]))
})